import Service from '../../services'

// initial state
const state = {
    overview: {
        graphs: []
    },
    dataAndStats: {
        graphs: [],
    },
    creativityIndex: {
        graphs: [],
    },
    graphDetail: {
        selectedIndustry: null,
        graphSort: ''
    },
    selectedYear: 0,
    availableYears: [],

    statistics: []
}

// getters
const getters = {}

// actions
const actions = {
    async populateOverviewGraph({commit, state}) {
        const statistics = await Service.statistic.getStatistic({
            paginate: false,
            is_display_overview: 1,
            year_data: state.selectedYear,
            order_by: 'ordering_overview',
        });
        commit('setOverview', {
            ...state.overview,
            graphs: statistics
        });
        return statistics
    },
    async populateDataAndStatsGraph({commit}, industryId) {
        const statistics = await Service.statistic.getStatistic({
            paginate: false,
            is_display_industry: 1,
            industry_id: industryId,
            mode_page: 'data-and-stats',
            order_by: 'ordering_industry',
        });
        commit('setDataAndStats', {
            ...state.dataAndStats,
            graphs: statistics
        });
        return statistics
    },
    async populateCreativityIndex({commit}) {
        const statistics = await Service.statistic.getStatistic({
            paginate: false,
            is_display_index: 1,
            mode_page: 'creativity',
            order_by: 'ordering_index',
        });
        commit('setCreativityIndex', {
            ...state.creativityIndex,
            graphs: statistics
        });
        return statistics
    },
    async populateDetail({ commit, state }, statisticId) {
        // console.log(state)
        const statistic = await Service.statistic.getStatisticById(statisticId, {
            industry_id: state.graphDetail.selectedIndustry,
            year_data: state.selectedYear,
            order_by: state.graphDetail.graphSort
        });
        commit('setGraphDetail', {
            ...state.graphDetail,
            ...statistic
        });
        return statistic
    },

    async populateStatistics ({ commit, state }, { keyword, lang }) {
        const params = {
            paginate: false,
            is_display_overview: 1
        }
        params[`title_${lang}`] = keyword

        const statistics = await Service.statistic.getStatistic(params)
        commit('setStatistics', statistics);
        return statistics
    },

    async populateAvailableYear({commit, state}) {
        const available_years = await Service.statistic.getAvailableYear();
        commit('setAvailableYears', available_years);
        commit('setSelectedYear', state.selectedYear
            ? state.selectedYear
            : Math.max(...available_years));
        return available_years
    },
    async setGraphSort({ commit }, sort) {
        commit('setGraphDetail', {
            ...state.graphDetail,
            graphSort: sort
        })
    },
    setGraphDetailSelectedIndustry({ commit, state }, industryId) {
        commit('setGraphDetail', {
            ...state.graphDetail,
            selectedIndustry: industryId
        })
    }
}

// mutations
const mutations = {
    setOverview(state, overview) {
        state.overview = overview
    },
    setStatistics(state, statistics) {
        state.statistics = statistics
    },
    setDataAndStats(state, dataAndStats) {
        state.dataAndStats = dataAndStats
    },
    setCreativityIndex(state, creativityIndex) {
        state.creativityIndex = creativityIndex
    },
    setGraphDetail(state, graphDetail) {
        state.graphDetail = graphDetail
    },
    setAvailableYears(state, availableYears) {
        state.availableYears = availableYears
    },
    setSelectedYear(state, selectedYear) {
        state.selectedYear = selectedYear
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
